export default {
    async mounted() {
        if (this.$config.recaptcha.enabled) {
            try {
                await this.$recaptcha.init();
            } catch (e) {
                this.$sentry.captureException(e);
            }
        }
    },
    beforeDestroy() {
        if (this.$config.recaptcha.enabled) {
            this.$recaptcha.destroy();
        }
    },
};
